const sanitizeHtmlMethod = require("sanitize-html");
let sanitizeUrl = require("@braintree/sanitize-url").sanitizeUrl;

export default {
  install(app) {
    app.mixin({
      methods: {
        textToSafeHtml(text, options = null) {
          if (typeof text !== "string") {
            return "";
          }

          text = utilities.nl2Br(text);
          return sanitizeHtmlMethod(text, options);
        },
        sanitizeHtml(html, options = {}) {
          if (typeof html !== "string") {
            return "";
          }

          return sanitizeHtmlMethod(html, options);
        },
        sanitizeLink(link) {
          if (typeof link !== "string") {
            return "";
          }

          return sanitizeUrl(link);
        },
        sanitizeUrl(link) {
          if (typeof link !== "string") {
            return "";
          }

          return sanitizeUrl(link);
        },
        sanitize(str) {
          if (typeof str !== "string") {
            warn("sanitize method can only sanitize strings!");
            return "";
          }

          try {
            new URL(str);
            return this.sanitizeLink(str);
          } catch (error) {
            // cant make a url from this so it is not a url

            try {
              return this.sanitizeHtml(str);
            } catch(error) {
              return '';
            }
          }
        },
      },
    });
  },
};
